/**
 * @nanokart/tryon-studio-sdk
 * Catalog Providers - Public exports
 */

export * from './types';
export { StaticItemsProvider } from './StaticItemsProvider';
export { UrlCatalogProvider, type UrlCatalogProviderOptions } from './UrlCatalogProvider';
export { PartnerCatalogProvider } from './PartnerCatalogProvider';

// ============================================================================
// Provider Factory
// ============================================================================

import { CatalogItem } from '../../types/config';
import { CatalogProvider } from './types';
import { StaticItemsProvider } from './StaticItemsProvider';
import { UrlCatalogProvider } from './UrlCatalogProvider';

export interface CreateCatalogProviderOptions {
  items?: CatalogItem[];
  catalogUrl?: string;
  catalogHeaders?: Record<string, string>;
  mapCatalogItem?: (raw: Record<string, unknown>) => CatalogItem;
}

/**
 * Create the appropriate catalog provider based on config.
 * Priority: items > catalogUrl > empty static
 */
export function createCatalogProvider(options: CreateCatalogProviderOptions): CatalogProvider {
  const { items, catalogUrl, catalogHeaders, mapCatalogItem } = options;

  if (items && items.length > 0) {
    return new StaticItemsProvider(items);
  }

  if (catalogUrl) {
    return new UrlCatalogProvider({
      catalogUrl,
      headers: catalogHeaders,
      mapItem: mapCatalogItem,
    });
  }

  return new StaticItemsProvider([]);
}
